import { subscribe, publish } from './keyEventSubPub'

let activeScopes = []
let scopes = []

/**
 * Events binding
 */
function bindEvent () {
  document.addEventListener('keydown', onKeyDown)
  document.addEventListener('keyup', onKeyUp)
  document.addEventListener('click', setActiveScopes)
  document.addEventListener('focusin', setActiveScopes)
}

function unbindEvent () {
  document.removeEventListener('keydown', onKeyDown)
  document.removeEventListener('keyup', onKeyUp)
  document.removeEventListener('click', setActiveScopes)
  document.removeEventListener('focusin', setActiveScopes)
}

function onKeyDown (e) {
  //if (!e.repeat) {
    publish(_getEventType(e), e, activeScopes)
  //}
}

function onKeyUp (e) {
  const eventType = _getEventType(e) + '+up'

  publish(eventType, e, activeScopes)
}

function setActiveScopes (e) {
  activeScopes = scopes.filter((scope) => {
    return e.target.closest(`.${scope}`) ? scope : null
  })
}

/**
 * Utils
 */
function _initScopes (scopes) {
  scopes.map(scope => {
    _addScope(scope)
  })
}

function _addScope(newScope) {
  scopes = [...scopes, newScope]
  scopes = [...new Set(scopes)]
}

function _getEventType(e) {
  let eventType;

  eventType = (e.ctrlKey ? 'ctrl+' : '') +
  (e.altKey ? 'alt+' : '') +
  (e.shiftKey ? 'shift+' : '') +
  (e.metaKey ? 'meta+' : '') +
  (e.key === ' ' ? 'Space' : e.key)

  return eventType
}

/**
 * Plugin
 */
const KeyEventBus = {
  install(Vue) {
    Vue.directive('keymap', {
      bind: bindEvent,
      unbind: unbindEvent,

      componentUpdated (el, binding) {
        if (binding.value !== binding.oldValue) {
          unbindEvent.apply(this, arguments)
          bindEvent.apply(this, arguments)
        }
        _initScopes(binding.value)
      }
    })

    Vue.mixin({
      data: function () {
        return {
          keyEventUnsubscribe: null
        }
      },

      methods: {
        keyEventSubscribe: function (scopes, keyEventMap) {
          let unsubscriptions = []

          scopes.map((scope) => {
            Object.entries(keyEventMap).map((entry) => {
              let unsubscription
              unsubscription = subscribe(entry[0], entry[1], scope)
              unsubscriptions.push(unsubscription)
            })
          })

          return () => {
            unsubscriptions.map((unsub) => {
              unsub.unsubscribe()
            })
          }
        },

        registerNewScope: function(newScope) {
          _addScope(newScope)
        }
      }
    })
  }
}
export default KeyEventBus